/**
 * Safe sessionStorage utilities that handle SSR and browser compatibility
 */

/**
 * Safely retrieves a value from sessionStorage
 * @param key - The storage key
 * @returns The stored value or null if not available
 */
export const getFromSessionStorage = (key: string): string | null => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return sessionStorage.getItem(key)
    }
    return null
  } catch {
    return null
  }
}

/**
 * Safely stores a value in sessionStorage
 * @param key - The storage key
 * @param value - The value to store
 */
export const setToSessionStorage = (key: string, value: string): void => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem(key, value)
    }
  } catch {
    // Silently fail if sessionStorage is not available
  }
}

/**
 * Safely removes a value from sessionStorage
 * @param key - The storage key to remove
 */
export const removeFromSessionStorage = (key: string): void => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.removeItem(key)
    }
  } catch {
    // Silently fail if sessionStorage is not available
  }
}

/**
 * Safely clears all sessionStorage
 */
export const clearSessionStorage = (): void => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.clear()
    }
  } catch {
    // Silently fail if sessionStorage is not available
  }
}
